<template lang="pug">
v-fade-transition(mode="in-out" class="tw-p-0 tw-m-0")
  v-container(fluid fill-height class=" pa-0  overflow-hidden")
    v-row(align="center" justify="center" class="fill-height tw-green-base")
      v-col(cols="12" md="5" class="")
        v-row(justify="center")
          v-col(cols="auto")
            span(class="text-h4 tw-text-indigo-lighten-2 tw-font-bold") Accept team invitation
        v-row(align="center" justify="center")
          v-col(class="text-center tw-border-blue-base")
            v-form(ref="form" v-model="valid" lazy-validation @keyup.native.enter="valid && register($event)")
              v-row
                v-col
                  v-text-field(
                    v-model="formData.name"
                    :rules="nameRules"
                    label="Name"
                    color="blue darken-4"
                    required
                  )
                v-col
                  v-text-field(
                    v-model="formData.lastName"
                    :rules="nameRules"
                    label="Last Name"
                    color="blue darken-4"
                    required
                  )
              v-text-field(
                v-model="formData.password"
                :rules="passwordRules"
                :type="'password'"
                name="input-10-1"
                label="Password"
                color="blue darken-4"
                required
              )
              v-text-field(
                v-model="passwordConfirm"
                :rules="passwordConfirmRules"
                :type="'password'"
                name="input-10-1"
                label="Confirm password"
                color="blue darken-4"
                required
              )
              v-btn(
                :loading="loading"
                color="rgba(94,129,244)"
                elevation="0"
                rounded
                @click="register"
                class=" tw-w-2/3 "
              )
                span(class="tw-font-bold") REGISTER

    v-snackbar(v-model="error" color="error")
      span {{ this.error_message }}
</template>
<script>
import AuthService from '@/services/AuthService';
export default {
  name: 'AcceptInvitation',
  data() {
    return {
      valid: true,
      error: false,
      error_message: '',
      formData: {},
      loading: false,
      passwordConfirm: '',
      passwordRules: [
        (v) => !!v || 'Please enter your password',
        //v => !v || /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(v) || 'Min. 8 characters with at least one capital letter and a number'
      ],
      passwordConfirmRules: [(v) => this.formData.password === this.passwordConfirm || 'Passwords must match'],
      emailRules: [
        (v) => !!v || 'Please enter your email',
        //v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
      ],
      nameRules: [(v) => !!v || 'Please enter your full name'],
    };
  },
  computed: {
    invitation() {
      return this.$route.params.invitation;
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.error = true;
        this.error_message = 'error';
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    register() {
      this.loading = true;
      this.formData.invitation = this.invitation;
      this.formData.name = this.formData.name + ' ' + this.formData.lastName;
      AuthService.registerUser(this.formData)
        .then(() => this.$router.push('/dashboard'))
        .catch((error) => {
          this.error_message = error;
          this.loading = false;
        });
    },
  },
};
</script>
